import React from "react";
import { Calendar, Wallet, User, ChevronLeft } from "lucide-react";
import moment from "moment";

function DetalhesEvento({ evento, onBack }) {
  if (!evento) return <p className="text-center mt-10">Selecione um evento.</p>;

  const handleCheckout = () => {
  const phone = "5511930135100";
  const message = `Olá, me interessei pelo evento ${evento.titulo}, que irá ocorrer no dia ${moment(evento.data).format("DD/MM/YYYY")}.`;
  const url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
  };


  return (
    <>
    <button
    onClick={onBack}
    className="relative top-2 left-2 bg-[#003D42] p-2 rounded-full z-10 flex items-center justify-center shadow-md w-9 h-9 hover:bg-[#00575e] transition"
    >
      <ChevronLeft size={20} color="#fff" />
    </button>
            
    <div className="max-w-lg md:max-w-[50vw] mx-auto rounded-lg bg-white p-4 shadow-md mt-6 relative"> 

      <img
        src={evento.foto}
        alt={evento.titulo}
        className="w-full h-auto object-cover rounded-md mb-6"
      />

      <p className="mb-4 text-justify">{evento.descricao}</p>

      <div className="space-y-3 text-gray-700 font-semibold">
        <div className="flex items-center gap-2">
          <Calendar size={18} />
          <span>Data: {moment(evento.data).format("DD/MM/YYYY")}</span>
        </div>
        <div className="flex items-center gap-2">
          <Wallet size={18} />
          <span>Investimento: R${evento.preco.toFixed(2)}</span>
        </div>
        <div className="flex items-center gap-2">
          <User size={18} />
          <span>Responsável: {evento.responsavel}</span>
        </div>
      </div>

      <button
        onClick={handleCheckout}
        className="mt-6 w-full rounded-md bg-[#003D42] py-3 text-white font-bold hover:bg-[#02514e] transition-colors"
      >
        Garanta o seu ingresso
      </button>
    </div>
    </>
  );
}

export default DetalhesEvento